import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { serviceGetHitos, serviceGetInforme } from '../../../api/api-consulta-hitos';
import { descargarArchivo } from '../../../common/descargarArchivo';
import { FaSearch } from "react-icons/fa";
import { LoadingComponent } from 'recupero-comunes';


const Historial = ({ proceso, idCaso, idOrgCaso, codTipoGestion }) => {
    const { SearchBar, ClearSearchButton } = Search;
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const columnas = [
        {
            dataField: 'glosaHito',
            text: 'Hito',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'fechaHitoFormat',
            text: 'Fecha Ocurrencia', sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'fechaAudienciaFormat',
            text: 'Fecha Audiencia', sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'comentario',
            text: 'Comentario',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'usuario',
            text: 'Usuario',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'fechaRegistroHitoFormat',
            text: 'Fecha Registro',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'opciones',
            text: '',
            isDummyField: true,
            style: { textAlign: 'center', verticalAlign: 'middle' },
            headerStyle: (colum, colIndex) => {
                return { width: '5%', textAlign: 'center', verticalAlign: 'center', backgroundColor: '#7594C1', color: 'white' }
            },
            formatter: (cell, row) => {
                return <FaSearch
                    size={20}
                    title={row.folioCarga ? "Ver Documentación del Hito" : "No existe documentación"}
                    style={{ color: 'gray', cursor: row.folioCarga ? 'pointer' : 'not-allowed' }}
                    onClick={() => handleInforme(row.folioCarga)}
                />
            },
        }
    ];

    useEffect(() => {
        getHistorialHitos();
    }, [proceso.idInstancia])


    const getHistorialHitos = async () => {
        setLoading(true);
        const query = Buffer.from(JSON.stringify({
            idCaso: idCaso,
            idImplicado: 999,
            idModoIngreso1: proceso.modoIngresoCompetencia,
            idModoIngreso2: null,
            tipoGestion: codTipoGestion,
            ambitoGestion: null,
            responsableReasignado: false,
            instanciaProceso: proceso.idInstancia
        })).toString('base64');

        const response = await serviceGetHitos(query);
        setLoading(false);
        setData(response);
    }

    const handleInforme = async (folioCarga) => {
        if (folioCarga) {
            setLoading(true);
            let query = Buffer.from(JSON.stringify({
                idCaso: idCaso,
                idImplicadoCaso: 0,
                idCompania: idOrgCaso,
                idfolioCarga: folioCarga
            })).toString('base64')

            const response = await serviceGetInforme(query);
            setLoading(false);

            descargarArchivo(response);
        }
    }

    return (
        <Container>
            <LoadingComponent show={loading} />
            <ToolkitProvider
                search
                bootstrap4
                keyField="secuencia"
                data={data ? data : []}
                columns={columnas}
                defaultSorted={[{ dataField: 'idHito', order: 'asc' }]}>
                {props =>
                    <>
                        <Row>
                            <Col className="d-grid d-md-flex justify-content-md-end mb-2">
                                <SearchBar {...props.searchProps} srText="" placeholder="Buscar en grilla" />
                                <ClearSearchButton {...props.searchProps} text="Limpiar" className="customSearch" />
                            </Col>
                        </Row>
                        <BootstrapTable
                            {...props.baseProps}
                            headerWrapperClasses="table-secondary"
                            noDataIndication={
                                <div className="text-center">No hay registros encontrados.</div>
                            }
                        />
                    </>
                }
            </ToolkitProvider>
        </Container>
    )
}

export default Historial;